<template>
  <canvas></canvas>
</template>

<script>
import { ArcElement, Chart, DoughnutController, Tooltip } from 'chart.js'

Chart.register(ArcElement, DoughnutController, Tooltip)

export default {
  props: {
    labels: {
      required: true,
      type: Array,
    },
    datasets: {
      required: true,
      type: Array,
    },
  },

  mounted() {
    this.elem = jQuery(this.$el)

    setTimeout(() => {
      this.initChart()
    })
  },
  methods: {
    initChart() {
      if (this.labels === null || this.datasets === null) {
        return
      }

      const ctx = this.elem[0].getContext('2d')

      this.chart = new Chart(ctx, {
        type: 'doughnut',
        data: {
          labels: this.labels,
          datasets: [
            {
              data: this.datasets[0].data,
              backgroundColor: this.datasets[0].backgroundColor,

              borderWidth: 0,
            },
          ],
        },
        options: {
          showAllTooltips: true,
          aspectRatio: 1,
          maintainAspectRatio: false,
          labelColor: ['#8b8b8b'],
          plugins: {
            datalabels: {
              display: false,
            },
            tooltip: {
              intersect: false,
              backgroundColor: '#fff',
              padding: 8,
              titleFont: {
                family: 'AeonikPro ,  sans-serif',
                size: 12,
                weight: 400,
              },
              titleColor: '#5B6069',
              bodyFont: {
                family: 'AeonikPro ,  sans-serif',
                size: 14,
                weight: 400,
              },
              bodyColor: '#5B6069',
              displayColors: false,
              callbacks: {
                title: function (context) {
                  return context[0].label
                },
                label: function (context) {
                  return `${context.formattedValue}%`
                },
              },
            },
          },
        },
      })
    },
  },
}
</script>
